import React from 'react';

const Blog = () => {
    return (
        <div>
            q:How does prototypical inheritance work? <br />
            ans: The Prototypal Inheritance is a feature in <br />
            javascript used to add methods and properties in objects. <br />
            It is a method by which an object can inherit the properties and methods <br />
            of another object. Traditionally, in order to get and set the [[Prototype]] <br />
            of an object, we use Object. getPrototypeOf and Object
            <br />
            <br />
            Q: What is a unit test? Why should we write unit tests? <br />
            ans: In computer programming, unit testing is a software <br />
            testing method by which individual units of source code—sets of <br />
            one or more computer program modules together with associated control <br />
            data, usage procedures, and operating procedures—are tested to determine whether <br />
            they are fit for use <br />
            <br />

            Q:  React vs. Angular vs. Vue? <br />
            ans: Vue provides higher customizability and <br />
            hence is easier to learn than Angular or React. Further , <br />
            Vue has an overlap with Angular and React with respect <br />
            to their functionality like the use of components. <br />
            Hence, the transition to Vue from either of the two is an easy option. <br />
            <br />
            Q:  What are the different ways to manage a state in a React application? <br />
            Ans: When we talk about state in our applications, <br />
             it’s important to be clear about what types of state actually matter. <br />


            There are four main types of state you need to properly manage in your React apps: <br />

           1. Local state <br />
            2. Global state <br />
            3.Server state <br />
            4.URL state <br />

        </div>
    );
};

export default Blog;